import { gql } from "@apollo/client";
import useData from "helpers/useData";
import useMobileLayout from "helpers/useMobileLayout";
import React from "react";

import ReelPlayer, { ReelPlayerFragment } from "./ReelPlayer";
import VideoPlayerDialog from "./VideoPlayerDialog";
import { CloseButton } from "./VideoPlayerDialogFooter";

export default function ReelPlayerDialog({ open, onClose, reelViewId }) {
  const [data] = useData(
    gql`
      query ReelPlayerDialog($reelViewId: ID!) {
        reelView(id: $reelViewId) {
          id
          ...ReelPlayerFragment
        }
      }
      ${ReelPlayerFragment}
    `,
    { reelViewId },
    { skip: !open },
  );
  const mobileLayout = useMobileLayout();

  return (
    <VideoPlayerDialog open={open} onClose={onClose}>
      <ReelPlayer
        reelView={data?.reelView}
        reelViewId={reelViewId}
        // a reel has no previous / next, so close sits in the header row instead of a footer; mobile has the dialog's X
        headerAction={!mobileLayout && <CloseButton onClose={onClose} />}
      />
    </VideoPlayerDialog>
  );
}
